export class ExtendedMap<T> extends Map<string, T> {
  concat(additionalExtMap: ExtendedMap<T>): ExtendedMap<T> {
    const MapConstructor = this.constructor as new (
      entries?: Iterable<[string, T]>
    ) => ExtendedMap<T>;

    const map = new MapConstructor(this);
    for (const [id, jep] of additionalExtMap) {
      map.set(id, jep);
    }
    return map;
  }

  map<R>(
    callbackfn: (value: T, id: string, index: number) => R
  ): ExtendedMap<R> {
    const MapConstructor = this.constructor as new (
      entries?: Iterable<[string, R]>
    ) => ExtendedMap<R>;

    const map = new MapConstructor();
    let index = 0;
    for (const [id, value] of this.entries()) {
      map.set(id, callbackfn(value, id, index));
      index++;
    }
    return map;
  }

  filter(
    callbackfn: (value: T, key: string, index: number) => boolean
  ): ExtendedMap<T> {
    const MapConstructor = this.constructor as new (
      entries?: Iterable<[string, T]>
    ) => ExtendedMap<T>;

    const map = new MapConstructor();
    let index = 0;
    for (const [key, value] of this.entries()) {
      if (callbackfn(value, key, index)) {
        map.set(key, value);
      }
      index++;
    }
    return map;
  }

  sort(callbackfn: (a: [string, T], b: [string, T]) => number): ExtendedMap<T> {
    const MapConstructor = this.constructor as new (
      entries?: Iterable<[string, T]>
    ) => ExtendedMap<T>;

    const sortedEntries = [...this.entries()].sort(callbackfn);
    return new MapConstructor(sortedEntries);
  }
}
